/** Parse sell-form storage labels like "256GB" / "1TB" to gigabytes. */
export function parseStorageLabelToGb(label: string): number | undefined {
  const raw = (label || '').trim()
  if (!raw) return undefined

  const upper = raw.toUpperCase()
  const tb = upper.match(/^(\d+(?:\.\d+)?)\s*TB$/)
  if (tb) {
    const n = Math.round(parseFloat(tb[1]) * 1024)
    return n > 0 ? n : undefined
  }

  const gb = upper.match(/^(\d+(?:\.\d+)?)\s*GB$/)
  if (gb) {
    const n = Math.round(parseFloat(gb[1]))
    return n > 0 ? n : undefined
  }

  const digits = upper.match(/^(\d+)$/)
  if (digits) {
    const n = parseInt(digits[1], 10)
    return Number.isFinite(n) && n > 0 ? n : undefined
  }

  return undefined
}
